<script setup>
import { computed } from 'vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import SettingsAccordion from 'dashboard/components-next/Settings/SettingsAccordion.vue';
import Input from 'dashboard/components-next/input/Input.vue';
import WahaConnection from './waha/WahaConnection.vue';
import WahaSettingsForm from './waha/WahaSettingsForm.vue';
import { useWahaSession } from './waha/useWahaSession';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

const sessionId = computed(() => props.inbox?.waha_session?.id);

const {
  session,
  qrCode,
  status,
  isLoading,
  isRefreshing,
  pendingAction,
  refresh,
  runAction,
  applySession,
} = useWahaSession(sessionId);

const details = computed(() => [
  ['SESSION_NAME', session.value?.session_name],
  ['INBOX_IDENTIFIER', session.value?.inbox?.identifier],
  ['WAHA_APP_ID', session.value?.waha_app_id],
  ['INBOX_WEBHOOK_URL', session.value?.inbox_webhook_url],
  ['WAHA_WEBHOOK_URL', session.value?.waha_webhook_url],
]);
</script>

<template>
  <div v-if="!sessionId" class="py-8 text-sm text-n-slate-11">
    {{ $t('INBOX_MGMT.WAHA.NOT_CONFIGURED') }}
  </div>

  <div v-else-if="isLoading || !session" class="flex justify-center py-12">
    <Spinner />
  </div>

  <div v-else class="flex flex-col gap-2 max-w-4xl pb-8">
    <WahaConnection
      :session="session"
      :status="status"
      :qr-code="qrCode"
      :is-refreshing="isRefreshing"
      :pending-action="pendingAction"
      class="mb-2"
      @refresh="refresh"
      @action="runAction"
    />

    <WahaSettingsForm :session="session" @saved="applySession" />

    <SettingsAccordion
      :title="$t('INBOX_MGMT.WAHA.SESSION_DETAILS')"
      :default-open="false"
    >
      <p class="text-sm text-n-slate-11">
        {{ $t('INBOX_MGMT.WAHA.SESSION_DETAILS_DESC') }}
      </p>
      <div class="grid gap-4 md:grid-cols-2">
        <Input
          v-for="[key, value] in details"
          :key="key"
          :model-value="value || ''"
          :label="$t(`INBOX_MGMT.WAHA.${key}`)"
          disabled
        />
      </div>
    </SettingsAccordion>
  </div>
</template>
